<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
    <NuxtLink
      v-for="pillar in pillars"
      :key="pillar.route"
      :to="localePath({ name: pillar.route })"
      class="group flex items-center gap-3 rounded-xl border border-primary-50 bg-white px-4 py-3 transition hover:border-primary-200 hover:shadow-sm"
    >
      <div class="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-secondary">
        <TIcon
          :icon="['fal', pillar.icon]"
          size="lg"
        />
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-semibold leading-snug">
          {{ pillar.title }}
        </p>
        <p class="text-xs text-gray-500 leading-snug mt-0.5">
          {{ pillar.description }}
        </p>
      </div>
      <TIcon
        :icon="['far', 'arrow-right']"
        class="shrink-0 text-gray-300 transition group-hover:text-secondary group-hover:translate-x-0.5"
        size="xs"
      />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@fortawesome/fontawesome-svg-core'
import { ROUTE_BASE_NAME } from '~/constants'

const props = defineProps<{
  focus?: 'guest' | 'host'
}>()

const { t } = useI18n()
const localePath = useLocalePath()

const pillars = computed<{ icon: IconName, title: string, description: string, route: string }[]>(() => [
  {
    icon: 'mobile',
    title: t('weMakeRvingEasy.title'),
    description: props.focus === 'guest' ? t('weMakeRvingEasy.descriptionGuest') : t('weMakeRvingEasy.description'),
    route: ROUTE_BASE_NAME.we_make_rving_easy,
  },
  {
    icon: 'headset',
    title: t('customerService.title'),
    description: t('customerService.description'),
    route: ROUTE_BASE_NAME.customer_service,
  },
])
</script>

<i18n lang="json">
{
  "en": {
    "weMakeRvingEasy": {
      "title": "We make RVing easy",
      "description": "Top-rated app, same-day payouts, and up to $2M insurance on every trip.",
      "descriptionGuest": "Top-rated app, instant booking, get the perfect RV delivered to your favorite campground."
    },
    "customerService": {
      "title": "Award-winning customer service",
      "description": "Real humans, under 5-min wait times, 24/7 roadside assistance."
    }
  },
  "fr": {
    "weMakeRvingEasy": {
      "title": "Nous facilitons le camping en VR",
      "description": "Application bien notée, versements le jour même et jusqu'à 2 M$ d'assurance.",
      "descriptionGuest": "Application bien notée, réservation instantanée, obtenez le VR parfait livré à votre site de camping préféré."
    },
    "customerService": {
      "title": "Service à la clientèle d'excellence",
      "description": "Humains réels, attente sous 5 min, assistance routière 24/7."
    }
  }
}
</i18n>
